export const seoConfig = {
    '/': {
        title: "HVAC Design, Installation & Maintenance",
        description: "Nikket Engineering Works provides expert HVAC design, installation, and maintenance services in Ahmedabad, Gujarat. Trusted HVAC solutions for commercial and industrial projects.",
        keywords: "HVAC ahmedabad, air conditioning installation, heating ventilation, HVAC design, HVAC maintenance, engineering works ahmedabad, nikket engineering"
    },
    '/who-we-are': {
        title: "About Us | Experienced HVAC Engineers",
        description: "Learn about Nikket Engineering Works - a team of experienced HVAC engineers providing top-quality heating, ventilation, and air conditioning solutions in Ahmedabad.",
        keywords: "about nikket engineering, HVAC engineers, HVAC company ahmedabad, engineering team, HVAC expertise"
    },
    '/our-services': {
        title: "Our Services | HVAC Design, Installation & Maintenance",
        description: "Comprehensive HVAC services including system design, installation, maintenance, and repair for commercial and industrial clients in Ahmedabad and Gujarat.",
        keywords: "HVAC services, AC installation, HVAC design services, HVAC maintenance, ventilation systems, commercial HVAC, industrial HVAC ahmedabad"
    },
    '/get-in-touch': {
        title: "Contact Us | Get a Quote for HVAC Services",
        description: "Get in touch with Nikket Engineering Works for HVAC consultations, quotes, and service requests. Based in Ahmedabad, Gujarat, serving clients across India.",
        keywords: "contact nikket engineering, HVAC quote, HVAC consultation, HVAC services ahmedabad, engineering contact"
    },
    '/service-requests': {
        title: "Service Requests | Schedule HVAC Maintenance",
        description: "Submit a service request for HVAC maintenance, repair, or installation with Nikket Engineering Works. Quick response and reliable service guaranteed.",
        keywords: "HVAC service request, AC repair, HVAC maintenance request, schedule HVAC service, nikket engineering service"
    },
};
